import { render } from "./AIDialog.vue?vue&type=template&id=11dd8c92&scoped=true&ts=true"
import script from "./AIDialog.vue?vue&type=script&lang=ts"
export * from "./AIDialog.vue?vue&type=script&lang=ts"

import "./AIDialog.vue?vue&type=style&index=0&id=11dd8c92&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dd8c92"]])

export default __exports__